module.exports = __webpack_public_path__ + "img/whole-face.f36cb14c.png";